// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"8610278a","110":"d8cd9b3a","178":"1b8db79f","233":"9c2d2fe6","722":"06f60855","854":"c670772d","869":"2e1efccf","953":"c2c6b57a"}[chunkId] + ".chunk.js";
};